// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3WFe9","title":"card_title__3GGhg","inActive":"card_inActive__28dXl"};